import { indexedSet, IndexedSet } from '../../utils/indexedSet';
import { indexedMap, IndexedMap } from '../../utils/indexedMap';
import { ResourceRegistry } from '../../resources/resourceRegistry';

export type TagCalculationResult = {
  tags: IndexedSet<string> | null;
  contexts: IndexedMap<unknown> | null;
};

export const calculateTags = ({
  typeName,
  params,
  data,
  resourceRegistry,
}: {
  typeName: string;
  params: any;
  data?: any;
  resourceRegistry: ResourceRegistry;
}): TagCalculationResult => {
  let linkTags: IndexedSet<string> | null = null;
  let contexts: IndexedMap<unknown> | null = null;

  resourceRegistry.forEachLink(typeName, (edge) => {
    const tagFn = data !== undefined ? edge.tagData : edge.tags;

    if (!tagFn) {
      return;
    }

    const results = tagFn({ data, params });

    if (!results || results.length === 0) {
      return;
    }

    const linkKey = edge.link.key;

    for (const result of results) {
      if (typeof result === 'string') {
        (linkTags ??= indexedSet()).add(linkKey, result);
      } else {
        (linkTags ??= indexedSet()).add(linkKey, result.tag);
        (contexts ??= indexedMap()).set(linkKey, result.tag, result.context);
      }
    }
  });

  return { tags: linkTags, contexts };
};
